<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 19 19">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="m11.16 9.81 7.81-7.8L17.56.58 9.74 8.4 1.93.6.5 2l7.82 7.81-7.74 7.75L2 18.97l7.74-7.74 7.75 7.74 1.4-1.41-7.73-7.75Z"
      clip-rule="evenodd"
    />
  </svg>
</template>
